import { _ as _defineProperty } from './defineProperty-Y-S4SptN.js';
import { _ as _objectWithoutProperties } from './objectWithoutProperties-w3bsUgPa.js';
import { useMemo, Children, cloneElement } from 'react';
import ReactDOM from 'react-dom';
import { usePopperTooltip } from 'react-popper-tooltip';
import classNames from 'classnames';
import { p as placementsList, u as useStyles } from './styles-S4eQkAfF.js';
import Logger from './services/logger/index.js';
import { j as jsxRuntimeExports } from './jsx-runtime-KJzvSKZ_.js';

var _excluded = ["toolTipContainerProps", "arrowProps", "children", "content", "placement", "offset", "popperOptions", "dataTest", "hideArrow", "isSmall", "interactive", "className", "zIndex", "usePortal", "visible", "withConsole"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var withPortal = function withPortal(children) {
  return /*#__PURE__*/ReactDOM.createPortal(children, document.body);
};
var defaultConfig = {};
function Tooltip(_ref) {
  var toolTipContainerProps = _ref.toolTipContainerProps,
    arrowProps = _ref.arrowProps,
    children = _ref.children,
    content = _ref.content,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? placementsList.auto : _ref$placement,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? [0, 4] : _ref$offset,
    _ref$popperOptions = _ref.popperOptions,
    popperOptions = _ref$popperOptions === void 0 ? defaultConfig : _ref$popperOptions,
    dataTest = _ref.dataTest,
    hideArrow = _ref.hideArrow,
    _ref$isSmall = _ref.isSmall,
    isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall,
    _ref$interactive = _ref.interactive,
    interactive = _ref$interactive === void 0 ? true : _ref$interactive,
    className = _ref.className,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? 99999 : _ref$zIndex,
    _ref$usePortal = _ref.usePortal,
    usePortal = _ref$usePortal === void 0 ? true : _ref$usePortal,
    visible = _ref.visible,
    withConsole = _ref.withConsole,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useStyles({
    zIndex: zIndex
  });
  var _usePopperTooltip = usePopperTooltip(_objectSpread({
      placement: placement,
      offset: offset,
      interactive: interactive,
      visible: visible
    }, props), popperOptions),
    getArrowProps = _usePopperTooltip.getArrowProps,
    getTooltipProps = _usePopperTooltip.getTooltipProps,
    setTooltipRef = _usePopperTooltip.setTooltipRef,
    setTriggerRef = _usePopperTooltip.setTriggerRef,
    isVisible = _usePopperTooltip.visible;
  var child = useMemo(function () {
    try {
      Children.only(children);
      return /*#__PURE__*/cloneElement(children, {
        ref: setTriggerRef
      });
    } catch (error) {
      Logger.error(error, withConsole);
      return /*#__PURE__*/jsxRuntimeExports.jsx("div", {});
    }
  }, [children, setTriggerRef, withConsole]);
  var tooltipContent = /*#__PURE__*/jsxRuntimeExports.jsxs("div", _objectSpread(_objectSpread({
    ref: setTooltipRef
  }, getTooltipProps(_objectSpread({
    className: classNames('tooltip-container', classes.inner, className, {
      isSmall: isSmall
    })
  }, toolTipContainerProps))), {}, {
    "data-test": dataTest,
    children: [content, !hideArrow && /*#__PURE__*/jsxRuntimeExports.jsx("div", _objectSpread({}, getArrowProps(_objectSpread({
      className: "tooltip-arrow ".concat(classes.arrow)
    }, arrowProps))))]
  }));
  return /*#__PURE__*/jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
    children: [child, isVisible && (usePortal ? withPortal(tooltipContent) : tooltipContent)]
  });
}

export { Tooltip as T };
//# sourceMappingURL=Tooltip-7wkLW4kK.js.map
